import { Env } from 'src/app/core/config/config.model';
import { URLS } from 'src/app/core/config/url.config';
import { OcapiApiApiKey, OneMirrorAccessToken } from 'src/app/utils/global-constants';
import { DoorwayElement, type Settings } from 'src/configs/settings/settings.interface';

export const settings: Partial<Settings> = {
  doorwayConfiguration: {
    disabled: [DoorwayElement.CarlUrl, DoorwayElement.BackendUrl, DoorwayElement.ConfigurationDate]
  },
  apis: {
    backend: {
      baseUrl: '../api/v3'
    },
    carl: {
      baseUrl: URLS.apis.owcc.prodCached,
      label: ''
    },
    deeplinks: {
      baseUrl: URLS.apis.deeplinks.test
    },
    ocapi: {
      baseUrl: URLS.apis.ocapi.test,
      apiKey: OcapiApiApiKey.Test
    },
    omds: {
      accessToken: OneMirrorAccessToken.Prod,
      baseUrl: URLS.apis.omds[Env.Prod],
      relayService: URLS.apis.omdsRelayService[Env.Prod]
    }
  },
  envSpecificMessage: 'INT - EXPERT'
};
